
const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue, Watch } from 'vue-property-decorator';

import { mainStore } from '../_store/main';

import { ShapeKeys, PointCloudDefinition } from '../_modules/webgl/PointCloud';

import PageComponent from '../_modules/PageComponent';
import MainGL from '../_modules/webgl/MainGL';
import RecruitInterviewItem from '../_modules/RecruitInterviewItem';
import Modal from '../_modules/Modal';

const RecruitScrollState = {
  KV: 'KV',
  CONTACT: 'CONTACT',
} as const;

export const RecruitGLDefinition: PointCloudDefinition = {
  KV: {
    key: 'KV',
    shapeKey: 'KV',
    isKV: true,
    order: 0,
    kvItems: [
      { key: '', shapeKey: ShapeKeys.HANDS, order: 0 },
   ]
  },
  CONTACT : { key: 'CONTACT' , shapeKey: ShapeKeys.CONTACT , order: 1 },
};


export default class Main extends PageComponent {
  protected memberEl!: HTMLElement;
  protected modal!: Modal;

  constructor() {
    super();
    this.init();
  }

  get isKV      () { return this.scrollState === RecruitScrollState.KV      }
  get isContact () { return this.scrollState === RecruitScrollState.CONTACT }

  protected async initObservers() {
    await this.wait(400);

    this.initPageKVObserver();
    this.initContactLinkObserver();
  }

  protected async init(): Promise<void> {
    mainStore.setCurrentPageId('recruit');

    this.scrollToTweenObj = { value: window.scrollY || window.pageYOffset };

    await Promise.all([
      g.loadFontPromise,
      this.initMainGL(),
      this.initLoading(),
      this.initHeader(),
      this.initFooter(),
      this.initMenu(),
    ]);

    await this.initContents();

    this.initMediaQuery();
    this.initScroll();
    this.initResize();

    this.resizeHandler();

    mainStore.setScrolled(false);
    mainStore.setLoaded(true);

    this.initObservers();

    await this.pageKV.$nextTick();

    this.isLocked = false;
    this.onResize();
    this.onScroll();
    this.play();
  }

  protected async initContents(): Promise<void> {
    await Promise.all([
      this.initPageKV(),
      this.initInterview(),
      this.initContact(),
      this.initModal(),
    ]);

    await super.initContents();
  }

  protected async initModal() {
    this.modal = new Modal({
      el: this.bodyElm.querySelector('.js-modal') as Element,
    });
    await this.modal.$nextTick();
  }

  protected async initInterview() {
    const promises: Promise<any>[] = [];
    const els = this.bodyElm?.querySelectorAll<HTMLElement>('.js-recruitInterviewItem');
    if(!els) return;
    for (let i = 0, l = els.length; i < l; i++) {
      const index = i;
      const item: RecruitInterviewItem = new RecruitInterviewItem({ el: els[i] });
      promises.push(this.onScreenItemManager.initItem(item));
      item.$on('clickinterviewitem', ()=> {
        const el = this.bodyElm.querySelector(`.js-interviewContents${index + 1}`);
        this.modal.setContents(
          (el?.querySelector('.js-head') as HTMLElement).innerHTML,
          (el?.querySelector('.js-contents') as HTMLElement).innerHTML,
        );
        this.modal.open();
      })
    }
    return Promise.all(promises);
  }

  protected async initMainGL() {
    const mainGLEl = this.bodyElm.querySelector('.js-mainGL') as HTMLElement;

    this.mainGL = new MainGL<typeof RecruitGLDefinition>(
      mainGLEl,
      mainGLEl.querySelector('canvas') as HTMLCanvasElement,
      RecruitGLDefinition,
      'KV',
      false
    );

    await this.mainGL.init()
    .catch((e)=> {
      console.log(e);
      this.htmlElm.classList.add('is-noWebGL');
      mainStore.setNoWebGL(true);
    })
    this.mainGL.onResize();
  }

  protected async onResize() {
    console.log('onResize');
    this.modal.onResize();
    await this.modal.$nextTick();
    this.mainGL.onResize();
    this.updateGLScales();
  }

  protected onScroll(): void {
    super.onScroll();
    this.mainGL.setScrollTop();
  }

  protected updateGLScales() {
    const kvImgEl = this.pageKV.getImgContainer()

    this.mainGL.setParams({
      KV: {
        imgSize: kvImgEl.offsetWidth || 1,
        offset: this.getOffsetImgItem(kvImgEl, true)
      },
      CONTACT: {
        imgSize: this.contactLinkImgEl.offsetWidth,
        offset: this.getOffsetImgItem(this.contactLinkImgEl)
      },
    })
  }

  public play(): void {
    super.play();

    this.mainGL.startLoop();
    this.updateGLScales();

    this.mainGL.play(()=> {
      this.isLocked = false;
      this.mainGL.setMode('KV');
      this.mainGL.setKVIndex(0);
      this.pageKV.play();
    }, false);
  }
}